document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.mm-nf[data-section-id]').forEach(function (section) {
        initNutritionFacts(section);
    });
});

function initNutritionFacts(section) {
    const items = Array.from(section.querySelectorAll('.mm-nf__item'));
    const desktopPanels = Array.from(section.querySelectorAll('.mm-nf__desktop-panel-item'));
    const desktopBreakpoint = window.matchMedia('(min-width: 990px)');

    if (!items.length) return;

    function closeAllItems() {
        items.forEach(function (item) {
            item.classList.remove('is-active');

            const trigger = item.querySelector('.mm-nf__trigger');
            if (trigger) {
                trigger.setAttribute('aria-selected', 'false');
            }

            const mobilePanel = item.querySelector('.mm-nf__mobile-panel');
            if (mobilePanel) {
                mobilePanel.hidden = true;
            }
        });
    }

    function setActiveItem(activeItem) {
        const activeIndex = activeItem.dataset.index;

        items.forEach(function (item) {
            const isActive = item === activeItem;
            item.classList.toggle('is-active', isActive);

            const trigger = item.querySelector('.mm-nf__trigger');
            if (trigger) {
                trigger.setAttribute('aria-selected', isActive ? 'true' : 'false');
            }

            const mobilePanel = item.querySelector('.mm-nf__mobile-panel');
            if (mobilePanel) {
                mobilePanel.hidden = !isActive;
            }
        });

        desktopPanels.forEach(function (panel) {
            const isActive = panel.dataset.index === activeIndex;
            panel.classList.toggle('is-active', isActive);
            panel.hidden = !isActive;
        });
    }

    items.forEach(function (item) {
        const trigger = item.querySelector('.mm-nf__trigger');
        if (!trigger) return;

        trigger.addEventListener('click', function () {
            if (item.classList.contains('is-active')) {
                if (!desktopBreakpoint.matches) {
                    closeAllItems();
                }
                return;
            }

            setActiveItem(item);
        });
    });

    desktopBreakpoint.addEventListener('change', function () {
        if (!desktopBreakpoint.matches) {
            return;
        }

        const activeItem = section.querySelector('.mm-nf__item.is-active') || items[0];
        if (activeItem) {
            setActiveItem(activeItem);
        }
    });
}
